// extracted by mini-css-extract-plugin
export default {"error-text":"formFieldErrorText_error-text__eyBxU"};